import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Payments Requests Status List
@return { Array }
*/
export const getPaymentsRequestsStatusList = state => {
  return state.paymentsRequestsStatusList
}

/** returns Payments Requests List
@return { Array }
*/
export const getPaymentsRequestsList = state => {
  return state.paymentsRequestsList
}

/** returns Payments Detail
@return { Array }
*/
export const getPaymentsDetail = state => {
  return state.paymentsDetail
}

/** returns Payments Requests hasMore value
@return { Boolean }
*/
export const getPaymentsRequestsHasMore = state => state.paymentsRequestsHasMore

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)
